var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 7.33333C10.8889 9.17428 9.3965 10.6667 7.55555 10.6667C5.7146 10.6667 4.22222 9.17428 4.22222 7.33333C4.22222 5.49238 5.7146 4 7.55555 4C9.3965 4 10.8889 5.49238 10.8889 7.33333Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 7.33333C19.7778 9.17428 18.2854 10.6667 16.4444 10.6667C14.6035 10.6667 13.1111 9.17428 13.1111 7.33333C13.1111 5.49238 14.6035 4 16.4444 4C18.2854 4 19.7778 5.49238 19.7778 7.33333Z",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2546 19.5555C15.3065 19.1927 15.3333 18.8217 15.3333 18.4444C15.3333 16.6276 14.7104 14.9562 13.6664 13.6323C14.4836 13.1595 15.4324 12.8889 16.4445 12.8889C19.5127 12.8889 22 15.3762 22 18.4444V19.5555H15.2546Z",
    fill: "#FA532E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55555 12.8889C10.6238 12.8889 13.1111 15.3762 13.1111 18.4444V19.5555H2V18.4444C2 15.3762 4.4873 12.8889 7.55555 12.8889Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntUsers);
export default __webpack_public_path__ + "static/media/ent-users.186dc5fd93427f5647606c570d21508f.svg";
export { ForwardRef as ReactComponent };